import React, { useState, useEffect } from 'react';
import { Grid, InputBase } from '@material-ui/core';
import { observer } from 'mobx-react-lite';
import { TextInput } from '../../store/inputs/TextInput';

const CTextInput = observer(({ item }: { item: TextInput }) => {
  const {
    label,
    value,
    placeholder,
    onChange,
    disabled,
    error,
    tag,
    required,
    isKey,
    isEdit,
  } = item;

  const [localValue, setLocalValue] = useState(value || '');

  useEffect(() => {
    setLocalValue(value || '');
  }, [value]);

  const isLocked = disabled || (isKey && isEdit);

  return (
    <Grid container spacing={3}>
      <Grid item xs={11} style={{ margin: '0 auto' }}>
        <div
          style={{
            border: error ? '1px solid #e53935' : '1px solid #e0e0e0',
            borderRadius: '10px',
            padding: '12px 16px',
            margin: '8px 0',
            background: isLocked ? '#fafafa' : '#fff',
            transition: 'border-color 0.15s ease',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
            <i
              className={isKey ? 'bx bx-key' : 'bx bx-text'}
              style={{ fontSize: '14px', color: '#757575', marginRight: '6px' }}
            />
            <span style={{ fontSize: '12px', fontWeight: 500, color: '#757575', textTransform: 'uppercase', letterSpacing: '0.4px' }}>
              {label}{required && <span style={{ color: '#e53935', marginLeft: '2px' }}>*</span>}
            </span>
          </div>
          <InputBase
            id={tag}
            type="text"
            value={localValue}
            placeholder={placeholder || `Enter ${label.toLowerCase()}...`}
            onChange={(e) => {
              setLocalValue(e.target.value);
              onChange(e.target.value as never);
            }}
            disabled={isLocked}
            fullWidth
            style={{
              fontSize: '14px',
              color: '#212121',
              padding: '4px 0',
              fontFamily: 'inherit',
            }}
          />
          {error && (
            <span style={{ fontSize: '11px', color: '#e53935', marginTop: '2px', display: 'block' }}>{error}</span>
          )}
        </div>
      </Grid>
    </Grid>
  );
});

export default CTextInput;
